import { addAdditionalRequest, DocumentDraft, DocumentLineMatch, isCatalogMatch, matchFor, ReviewLine } from './result-model'

export type ExcessRow = {
  line: number; name: string; issue_code?: string; issue?: string; actual?: string; unit?: string; remaining?: number
  excess?: { actual: string; covered: string; quantity: string; unit: string; request_number?: string; approved?: boolean }
}
export type AdditionalRequestRow = { source: ReviewLine; draft: DocumentDraft['items'][number]; quantity: string; unit: string }
export type RequestAssignments = Record<number, DocumentLineMatch>
export const requestIdentity = (match: DocumentLineMatch) => JSON.stringify([match.document_number, match.source_line_id])
export const requestFits = (row: AdditionalRequestRow, match: DocumentLineMatch) => {
  const primary = matchFor(row.source, row.draft)
  return match.dataset === 'requests' && !!match.request_position_uuid && !!match.source_line_id && !!match.unit_id
    && !!primary?.product_id && primary.product_id === match.product_id
    && (isCatalogMatch(primary) || (primary.variant_id || '') === (match.variant_id || ''))
    && (isCatalogMatch(primary) || primary.request_position_uuid !== match.request_position_uuid)
}
export const suggestRequests = (rows: AdditionalRequestRow[], items: DocumentLineMatch[], current: RequestAssignments): RequestAssignments => {
  const next = { ...current }
  for (const row of rows) {
    if (next[row.source.line_number]) continue
    const candidates = items.filter(item => requestFits(row, item))
    if (candidates.length === 1) next[row.source.line_number] = candidates[0]
  }
  return next
}
export const applyAdditionalRequests = (lines: ReviewLine[], draft: DocumentDraft, assignments: RequestAssignments): DocumentDraft => {
  for (const key of Object.keys(assignments)) {
    if (!lines.some(line => line.line_number === Number(key)) || !draft.items.some(row => row.line_number === Number(key)))
      throw new Error('Состав накладной изменился. Откройте подбор заново')
  }
  return { ...draft, items: draft.items.map(row => {
    const match = assignments[row.line_number]
    return match ? addAdditionalRequest(lines.find(line => line.line_number === row.line_number)!, row, match) : row
  }) }
}
